import { FC, createContext, useContext, useState, ReactNode } from 'react'

type AppContexttType = {
  isFooterVisible: boolean
  setFooterVisible: (value: boolean) => void
}

const AppContext = createContext<AppContexttType | null>(null)

export const AppContextProvider: FC<{
  children?: ReactNode | ReactNode[]
}> = ({ children }) => {
  const [isFooterVisible, setFooterVisible] = useState(false)

  return (
    <AppContext.Provider
      value={{
        isFooterVisible,
        setFooterVisible,
      }}
    >
      {children}
    </AppContext.Provider>
  )
}

export const useAppContext = () => {
  const context = useContext(AppContext)
  return context as AppContexttType
}
